import { FC } from 'react'
import Button from 'components/ui/Button'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import { RangePicker as RangePickerExternal } from 'react-ease-picker'

interface IRangePicker {
  startDate: any
  endDate: any
  setStartDate: (start: any) => void
  setEndDate: (start: any) => void
}

const RangePicker: FC<IRangePicker> = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {
  return (
    <Button
      className="!w-64 !p-0 !pl-5"
      startIcon={<CalendarTodayOutlinedIcon />}
    >
      <RangePickerExternal
        format="MMM DD, YYYY"
        startDate={startDate}
        endDate={endDate}
        className="h-[42px] w-full rounded-lg focus:outline-none cursor-pointer"
        onSelect={(start, end) => {
          setStartDate(start)
          setEndDate(end)
        }}
        position="right"
      />
    </Button>
  )
}

export default RangePicker
